<div>
    <div class="modal-header">
        <h4 class="modal-title">{{notificationPopupMode.title}}</h4>
        <span class="logo-btn-small close white" (click)="activeModal.dismiss('Cross click')"></span>
    </div>
    <div class="modal-body d-flex flex-column">
        <div class="d-flex flex-row">
            <div class="px-p-15"><em class="material-icons md-65 color-gray">info_outline</em></div>
            <div class="px-p-10">
                <div class="px-px-10 fs-15px">{{notificationPopupMode.text}}</div>
                <div class="color-bnpp-green px-p-10 fs-14px">{{notificationPopupMode.question}}</div>
            </div>
        </div>
    </div>

    <div class="modal-footer mt-auto">
        <button type="button" class="btn btn-sm btn-basic" (click)="activeModal.close('cancel')">CANCEL</button>
        <button type="button" class="btn btn-sm btn-basic bnpp-btn" (click)="activeModal.close('ok')">
            {{notificationPopupMode.continueButton}}
        </button>
    </div>
</div>
